module.exports = __webpack_public_path__ + "img/part-4-info.3fe698ed.png";